<template>
  <div>
    <h2>Hello {{ employeeName }}</h2>
    &nbsp;
    <p>
      The following questions are being to determine information in your
      industry & region in order to create a baseline of data. You will have
      several options in regard to whom has access to your data and what data
      they will receive.
    </p>
    <el-form @submit.native.prevent>
      <label role="text"
        >In answering this set of questions, you may choose to answer, state it
        is not applicable or choose not to respond:</label
      >

      <div class="ts-comp--multiselect columned" id="checkboxes">
        <el-table :data="surveyItems" style="width: 100%">
          <el-table-column property="Title" width="430"> </el-table-column>

          <el-table-column label="Yes" width="100">
            <span style="margin-left: 3px"
              ><label class="el-checkbox">
                <span class="el-checkbox__input">
                  <span class="el-checkbox__inner"></span>
                  <input
                    type="checkbox"
                    aria-hidden="false"
                    class="el-checkbox__original"
                    @click="handleChange"
                  />
                </span>
              </label>
            </span>
          </el-table-column>

          <el-table-column label="No" width="100">
            <span style="margin-left: 2px">
              <label class="el-checkbox">
                <span class="el-checkbox__input">
                  <span class="el-checkbox__inner"></span>
                  <input
                    type="checkbox"
                    aria-hidden="false"
                    class="el-checkbox__original"
                    @click="handleChange"
                  /> </span
                ><!---->
              </label>
            </span>
          </el-table-column>

          <el-table-column label="N/A" width="100" center>
            <span style="margin-left: 4px">
              <label class="el-checkbox">
                <span class="el-checkbox__input">
                  <span class="el-checkbox__inner"></span>
                  <input
                    type="checkbox"
                    aria-hidden="false"
                    class="el-checkbox__original"
                    @click="handleChange"
                  /> </span
                ><!---->
              </label>
            </span>
          </el-table-column>

          <el-table-column label="I prefer not to answer" width="170">
            <span style="margin-left: 60px">
              <label class="el-checkbox">
                <span class="el-checkbox__input">
                  <span class="el-checkbox__inner"></span>
                  <input
                    type="checkbox"
                    aria-hidden="false"
                    class="el-checkbox__original"
                    @click="handleChange"
                  /> </span
                ><!---->
              </label>
            </span>
          </el-table-column>
        </el-table>
      </div>

      &nbsp;

      <el-alert
        v-if="hasError"
        title="All items are required."
        type="error"
        show-icon
      ></el-alert>

      <button
        class="ts-btn ts-btn-rounded ts-btn-secondary"
        @click="storeSection"
      >
        Complete
      </button>
    </el-form>

    &nbsp;
  </div>
</template>

<script>
import * as $ from "jquery";

export default {
  created() {
    this.$store.dispatch("jobseeker/getsurvey").then((res) => {
      this.surveyItems = res;
    });

    this.$store.dispatch("jobseeker/getsurveycaptured").then((res) => {
      if (res != null) {
        this.employeeSurvey = res;
        this.employeeSurvey.RatedSelection.forEach((e) => {
          for (const a of document.querySelectorAll("div")) {
            if (a.textContent == e.Selection) {
              var tableRow = a.parentElement.parentElement;
              if (e.Value == "YES") {
                tableRow.firstElementChild.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
                tableRow.firstElementChild.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
              } else if (e.Value == "NO") {
                tableRow.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
                tableRow.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
              } else if (e.Value == "NA") {
                tableRow.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
                tableRow.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
              } else {
                tableRow.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
                tableRow.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.add(
                  "is-checked"
                );
              }
            }
          }
        });
      }
    });
  },
  data() {
    return {
      isLoading: false,
      hasError: false,
      role: {},
      employeeSurvey: {},
      surveyItems: [],
      CapturedSurvey: {},
    };
  },
  computed: {
    employeeName() {
      return this.$store.state.account.current_user.fullName;
    },
  },
  methods: {
    storeSection() {
      this.isLoading = this;
      var QuestionItems = [];
      $("label.el-checkbox.is-checked").each(function () {
        var span = $(this).parent(); // parent of label.el-checkbox.is-checked
        var div = span.parent();
        var td = div.parent();
        var tr = td.parent();
        var titletd = tr.find(".el-table_1_column_1  ");

        var itemClass = td.attr("class");
        var itemTitle = titletd.find(".cell").html();

        var itemValue = "";
        if (itemClass == "el-table_1_column_2  ") {
          itemValue = "YES";
        } else if (itemClass == "el-table_1_column_3  ") {
          itemValue = "NO";
        } else if (itemClass == "el-table_1_column_4  ") {
          itemValue = "NA";
        } else {
          itemValue = "PNTA";
        }

        var obj = {};
        obj = { Selection: itemTitle, Value: itemValue };
        QuestionItems.push(obj);
      });

      this.CapturedSurvey.RatedSelection = QuestionItems;

      if (
        this.CapturedSurvey.RatedSelection.length == this.surveyItems.length
      ) {
        this.$store
          .dispatch("jobseeker/capturedsurvey", this.CapturedSurvey)
          .then((res) => {
            this.$message.success("Anonymous survey has been saved.");
          })
          .catch((res) => {
            this.modelState = res.errors;
            this.hasError = true;
          })
          .finally((res) => {
            this.isLoading = false;
            this.$router.push({ name: "jobseeker-dashboard" });
          });
      } else {
        this.hasError = true;
      }
    },
    handleChange(e) {
      var row =
        e.currentTarget.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement;

      var firstChild = row.firstElementChild;
      var secondChild = firstChild.nextElementSibling;
      secondChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );
      secondChild.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );

      var thirdChild = secondChild.nextElementSibling;
      thirdChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );
      thirdChild.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );

      var fourthChild = thirdChild.nextElementSibling;
      fourthChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );
      fourthChild.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );

      var fifthChild = fourthChild.nextElementSibling;
      fifthChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );
      fifthChild.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.remove(
        "is-checked"
      );

      e.currentTarget.parentElement.parentElement.classList.add("is-checked");
      e.currentTarget.parentElement.classList.add("is-checked");
    },
  },
};
</script>
